<nav class="navbar navbar-expand-lg navbar-light header-navbar {{transparentBGClass}}"
  [ngClass]="{'navbar-brand-center': menuPosition === 'Top', 'navbar-static': menuPosition === 'Side' &&
  config?.layout.navbar.type === 'Static' , 'navbar-sticky': menuPosition === 'Side' &&
  config?.layout.navbar.type === 'Fixed', 'fixed-top': isSmallScreen && menuPosition === 'Top'}">
  <div class="container-fluid navbar-wrapper">
    <div class="navbar-header d-flex">

    </div>
    <div class="navbar-container">
      <div class="collapse navbar-collapse d-block" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="dropdown nav-item mr-1" placement="bottom-left" display="static" ngbDropdown >
            <a class="nav-link dropdown-toggle user-dropdown d-flex align-items-end" id="dropdownBasic2"
              href="javascript:;" data-toggle="dropdown" ngbDropdownToggle>
              <div class="user d-md-flex d-none mr-2">
                <span class="text-right">{{ userinfo.firstname }} {{ userinfo.lastname }}</span>
                <span
                  class="text-right text-muted font-small-3"> Grupo Alpha </span>
              </div>
              
              <img class="avatar" src="assets/img/portrait/small/Picture2.png" alt="avatar" height="35" width="35" />
            </a>
            <div class="dropdown-menu text-left dropdown-menu-right m-0 pb-0" aria-labelledby="dropdownBasic2"
              ngbDropdownMenu>
              <div class="dropdown-divider"></div>

<!--               <a class="dropdown-item" routerLink="/page/account-settings">
                <div class="d-flex align-items-center">
                  <i class="ft-edit mr-2"></i><span>Editar Perfil</span>
                </div>
              </a>
 -->
              <a class="dropdown-item" (click) = "logout()">
                <div class="d-flex align-items-center">
                  <i class="ft-power mr-2"></i><span>Cerrar sesion</span>
                </div>
              </a>

            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>





</nav>
